/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 *
 * @param {*} obj
 */
module.exports = function isDOMElement(obj) {
  return obj && typeof obj === 'object' && obj.nodeType === Node.ELEMENT_NODE;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/utils/lib/isDOMElement.js
// module id = 651
// module chunks = 2